module.exports = __webpack_public_path__ + "img/icon-check.538e7b45.svg";